export const INFO = 'view_all_products_alert.info';
export const BUTTON = 'view_all_products_alert.button';
